import React, { createContext, ReactNode, useContext, useState } from "react";

type ListaContext = {
    listaPedidosSelecionados: number[],
    togglePedidoSelecionado: (idPedido: number, somenteAdicionar: boolean) => void,
    limparListaPedidosSelecionados: () => void,
    temPedidoSelecionado: boolean
}

export const ListaContext = createContext<ListaContext | null>(null)

export function ListaContextProvider(props: { children: ReactNode }) {
    const [listaPedidosSelecionados, setListaPedidosSelecionados] = useState<number[]>([]);

    const togglePedidoSelecionado = (idPedido: number, somenteAdicionar = false) => {
        setListaPedidosSelecionados(prev => {
            const indexPedido = prev.findIndex(id => id === idPedido)

            if (indexPedido === -1)
                return [...prev, idPedido]
            else if (!somenteAdicionar)
                prev.splice(indexPedido, 1)

            return [...prev]
        })
    }

    const value = {
        listaPedidosSelecionados,
        togglePedidoSelecionado,
        limparListaPedidosSelecionados: () => setListaPedidosSelecionados(prev => []),
        temPedidoSelecionado: listaPedidosSelecionados.length > 0,
    }

    return <ListaContext.Provider value={value}>{props.children}</ListaContext.Provider>
}

const useListaContext = () => {
    const context = useContext(ListaContext)

    if (!context) throw new Error("useListaContext must be within a Context Provider")

    return context
}

export default useListaContext
